module.exports = __webpack_public_path__ + "img/storePrice.2e051eb5.png";